(() => {
  'use strict';
  const email = 'hello@ledspace-projects.com';
  function initialise() {
    const dialog = document.querySelector('[data-lspe]');
    if (!dialog || dialog.dataset.ready === 'true') return;
    const triggers = [...document.querySelectorAll('[data-lspe-open]')];
    if (!triggers.length || typeof dialog.showModal !== 'function') return;
    let body;
    try { body = JSON.parse(dialog.querySelector('[data-lspe-body]').textContent).join(''); } catch { return; }
    dialog.dataset.ready = 'true';
    document.body.appendChild(dialog);
    const subject = dialog.dataset.subject;
    const encoded = {email: encodeURIComponent(email), subject: encodeURIComponent(subject), body: encodeURIComponent(body)};
    const mailto = `mailto:${email}?subject=${encoded.subject}&body=${encoded.body}`;
    const links = {
      gmail: `https://mail.google.com/mail/?view=cm&fs=1&to=${encoded.email}&su=${encoded.subject}&body=${encoded.body}`,
      outlook: `https://outlook.office.com/mail/deeplink/compose?to=${encoded.email}&subject=${encoded.subject}&body=${encoded.body}`,
      yahoo: `https://compose.mail.yahoo.com/?to=${encoded.email}&subject=${encoded.subject}&body=${encoded.body}`,
      device: mailto
    };
    const mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
    const providers = [...dialog.querySelectorAll('[data-lspe-provider]')];
    for (const a of providers) {
      a.href = links[a.dataset.lspeProvider];
      if (mobile) {
        if (a.dataset.lspeProvider === 'gmail') { a.textContent = dialog.dataset.compose; a.href = mailto; a.removeAttribute('target'); a.removeAttribute('rel'); }
        else a.hidden = true;
      }
    }
    if (mobile) dialog.querySelector('[data-lspe-intro]').textContent = dialog.dataset.mobileIntro;
    let previousFocus;
    for (const a of triggers) {
      a.href = mailto;
      a.addEventListener('click', e => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault(); previousFocus = a;
        if (!dialog.open) { dialog.showModal(); document.documentElement.classList.add('lspe-open'); }
        dialog.querySelector('[data-lspe-provider="gmail"]').focus();
      });
    }
    dialog.querySelector('[data-lspe-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { document.documentElement.classList.remove('lspe-open'); dialog.querySelector('[data-lspe-status]').textContent = ''; previousFocus?.focus(); });
    dialog.querySelector('[data-lspe-copy]').addEventListener('click', async () => {
      const status = dialog.querySelector('[data-lspe-status]');
      try { await navigator.clipboard.writeText(email); status.textContent = dialog.dataset.copied; }
      catch { status.textContent = dialog.dataset.copyFailed; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once: true}); else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
